import BatFlapping from "components/BatFlapping";

import { SelectableLink, SelectableLinkContainer } from "components/Link";
import Modal from "components/Modal";
import { Text } from "components/Text";
import { white } from "core/styles";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { desktop } from "submodules/sharedText/flavor";
import { generateSessionName } from "utils/sessionNameGenerator";
import { StyledButton } from "./Button/v2";
import TextInput from "./TextInput/v2";

const { general, exitModal } = desktop;
const flavor = { ...general, ...exitModal };

const LoadingContainer = styled.div`
  position: fixed;
  top: 20.5vw;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalContent = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  color: ${white};
`;

const SessionNameModal = ({
  showModal,
  onEnterSessionName,
  error,
  isLoading,
  onClose,
}) => {
  const [sessionName, setSessionName] = useState(generateSessionName());

  return (
    <Modal isOpen={showModal} close={onClose}>
      <Wrapper>
        {isLoading && (
          <LoadingContainer>
            <BatFlapping />
          </LoadingContainer>
        )}
        <ModalContent>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (!isLoading) {
                onEnterSessionName(sessionName);
              }
            }}
          >
            <TextInput
              isLong
              label={"Room"}
              value={sessionName}
              onChange={setSessionName}
              maxLength={4}
              upperCased
              data-test-id="session-name-input"
            />
          </form>
          <Text isError>{error}</Text>
          <SelectableLinkContainer>
            <StyledButton
              data-test-id="session-name-submit"
              onClick={() => {
                if (!isLoading) {
                  onEnterSessionName(sessionName);
                }
              }}
            >
              Create Room
            </StyledButton>
            <StyledButton data-test-id="session-name-cancel" onClick={onClose}>
              Cancel
            </StyledButton>
          </SelectableLinkContainer>
        </ModalContent>
      </Wrapper>
    </Modal>
  );
};
export default SessionNameModal;
